import React, { useEffect, useMemo, useState } from 'react'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import Box from '@mui/material/Box'

import SearchBarWithRecent from 'components/common/SearchBarWithRecent'
import useInnovaTheme from 'components/common/hooks/useInnovaTheme'
import { PickList } from './SimplePickListDialog'
import { searchFunction } from './searchFunctions'
import { filter as _filter } from 'lodash'

const SectionPickListDialog = (props) => {
  const {
    title,
    items,
    open,
    setOpen,
    onApply,
    initSelItems,
    singleItemSelect = false,
    showSearch = false,
    searchParams = [],
  } = props

  const { searchBarStyle } = useInnovaTheme()
  const [selectedItems, setSelectedItems] = useState(Array.isArray(initSelItems) ? initSelItems : [])
  const [searchText, setSearchText] = useState('')

  useEffect(() => {
    setSelectedItems(Array.isArray(initSelItems) ? initSelItems : [])
  }, [initSelItems])

  const filteredSections = useMemo(() => {
    if (!showSearch) return items
    const searchTxt = (searchText ?? '').trim()
    if (!searchTxt) return items
    if (!Array.isArray(items) || !Array.isArray(searchParams)) return items

    const formattedQuery = searchTxt.toLowerCase()
    const out = []

    items.forEach((section) => {
      const next = { ...section, data: [] }
      next.data = _filter(section?.data ?? [], (item) => {
        return searchFunction ? searchFunction(item, formattedQuery, searchParams) : true
      })
      if (next.data.length > 0) out.push(next)
    })

    return out
  }, [items, searchText, showSearch, searchParams])

  return (
    <Dialog
      PaperProps={{
        sx: {
          backgroundColor: 'itemBackground',
          minWidth: '50vh',
        },
      }}
      open={open}
      onClose={() => setOpen(false)}>
      <DialogTitle>{title}</DialogTitle>

      <DialogContent sx={{ pt: 0, overflow: 'hidden' }}>
        {showSearch ? (
          <Box sx={{ mb: 0.75 }}>
            <SearchBarWithRecent
              value={searchText}
              onChange={(newSearchTerm) => setSearchText(newSearchTerm)}
              onCancelSearch={() => setSearchText('')}
              style={searchBarStyle()}
              recentKey="sectionPickListDialog"
            />
          </Box>
        ) : null}

        <PickList
          sections={filteredSections}
          value={selectedItems}
          onChange={setSelectedItems}
          single={!!singleItemSelect}
          getId={(item) => item.id}
          getLabel={(item) => item.desc}
          maxHeight={520}
        />
      </DialogContent>

      <DialogActions>
        <Button variant="outlined" onClick={() => setOpen(false)} color="secondary">
          Cancel
        </Button>
        <Button
          variant="contained"
          onClick={() => {
            setOpen(false)
            onApply(selectedItems)
          }}
          color="primary">
          Apply
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default SectionPickListDialog
